import * as React from "react";
const SvgFavorite = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#969696", d: "m10 13.75-4.4 2.7 1.19-5.03-3.92-3.36 5.15-.42L10 2.89l1.98 4.76 5.15.42-3.92 3.36 1.2 5.02z" }));
export default SvgFavorite;
